import { $message } from '@nio-fe/lego';
// 主题
export const setTheme = (theme: string) => {
  document.documentElement.setAttribute('theme', theme);
};

export const resMessage = (
  res: { result_code: string; display_msg?: string },
  successMsg: string
) => {
  if (['success', 'ok'].includes(res.result_code)) {
    $message({
      message: successMsg,
      type: 'success',
    });
  } else {
    $message.error(res.display_msg || '接口报错');
  }
};
